import Main from 'components/Shared/Main'
export default Main
